import { observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatCurrency } from 'Util/_HumanWritten/CurrencyUtils';
import { isNotNullOrUndefined, isNullOrUndefined, stringNotEmpty } from 'Util/TypeGuards';
import { KNOWN_NON_CARD_OPTIONS, PaymentMethodId } from 'Views/Components/_HumanWritten/Payment/PaymentTypeWrapper';
import If from 'Views/Components/If/If';

export interface AmountPayableProps {
	totalPrice?: number;
	activePaymentMethod?: PaymentMethodId;
	dynamicSurcharge?: number;
}

function AmountPayable({ totalPrice, activePaymentMethod, dynamicSurcharge }: AmountPayableProps) {
	const isSavedCard = !!activePaymentMethod && !KNOWN_NON_CARD_OPTIONS.includes(activePaymentMethod);
	const includeFees =
		activePaymentMethod === 'credit-card-option' ||
		activePaymentMethod === 'eftpos-option' ||
		activePaymentMethod === 'terminal-option' ||
		isSavedCard;

	return (
		<div className="amount-payable__container">
			<p className="total-amount__header">
				<FormattedMessage id="payment-tab__total-amount__header" defaultMessage="Total amount" />
			</p>
			<>
				<If condition={isNotNullOrUndefined(totalPrice)}>
					<h4 className="total-amount__price">
						{formatCurrency((totalPrice ?? 0) + (includeFees ? (dynamicSurcharge ?? 0) : 0))}
					</h4>
				</If>
				<If condition={isNotNullOrUndefined(dynamicSurcharge) && includeFees && dynamicSurcharge > 0}>
					<p className="credit-card-surcharge__price">
						<FormattedMessage
							id="payment-tab__credit-card-surcharge__label"
							defaultMessage="Includes card fee of {surcharge}"
							values={{
								surcharge: formatCurrency(dynamicSurcharge ?? 0),
							}}
						/>
					</p>
				</If>
			</>
		</div>
	);
}

export default observer(AmountPayable);
